import api from "./axios";

export const getConversion = async (conversationId) => {
  try {
    const response = await api.get(`/api/v1/customer/chat/get-messages/${conversationId}`);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
};

export const chatRequest = async (data) => {
  try {
    const response = await api.post(`/api/v1/customer/chat/request`, data);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}

export const getMatchReasons = async () => {
  try {
    const response = await api.get(`/api/v1/customer/matches/unmatch-reasons`);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}
export const updateMatchRequest = async (data) => {
  try {
    const response = await api.post(`/api/v1/customer/matches/unmatch`, data);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}

export const getReportReason = async () => {
  try {
    const response = await api.get(`/api/v1/customer/matches/report-reasons`);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}
export const updateReportReason = async (data) => {
  try {
    const response = await api.post(`/api/v1/customer/matches/report`, data);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}

export const blockMatches = async (data) => {
  try {
    const response = await api.post(`/api/v1/customer/matches/block`, data);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}
export const createChatRoom = async (data) => {
  try {
    const response = await api.post(`/api/v1/customer/chat/create-room`, data);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}
export const getMatchListById = async (id) => {
  try {
    const response = await api.get(`/api/v1/customer/matches/check-match/${id}`);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}
export const getLastedConversion = async () => {
  try {
    const response = await api.get(`/api/v1/customer/chat/get-conversations?limit=1`);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}

export const getMatches = async (page) => {
  try {
    const response = await api.get(`/api/v1/customer/matches?page=${page}`);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}

export const getChatRoom = async (participantId, token = null) => {
  try {
    let url = `/api/v1/customer/chat/get-user-first-conversation/${participantId}`;
    if (token) {
      url += `?token=${encodeURIComponent(token)}`;
    }
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}
export const messageSeen = async (conversationId) => {
  try {
    const response = await api.post(`/api/v1/customer/chat/message-seen`, { conversationId: conversationId, });
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}

export const markConversationAsSeen = async (participantId) => {
  try {
    const response = await api.post(`/api/v1/customer/chat/mark-conversation-seen`, { participantId });
    return response.data;
  } catch (error) {
    console.error(error.response?.data?.message || "Something went wrong")
  }
}

export const sendMessage = async (messageData) => {
  try {
    const response = await api.post('/api/v2/user/chat/sendMessage', messageData);
    return response.data;
  } catch (error) {
    console.error("Failed to send message:", error.response?.data?.message || error.message);
    return {
      success: false,
      error: error.response?.data?.message || error.message
    };
  }
};